import { createTheme } from "@mui/material/styles";
import { red } from "@mui/material/colors";

declare module "@mui/material/styles" {
  // interface BreakpointOverrides {
  // 	xs: true; // removes the `xs` breakpoint
  // 	sm: false;
  // 	md: false;
  // 	lg: false;
  // 	xl: false;
  // 	mobile: true; // adds the `mobile` breakpoint
  // 	tablet: true;
  // 	laptop: true;
  // 	desktop: true;
  // 	tv: true; //! this is unecessary.
  // }

  interface PaletteOptions {
    custom: {
      white: string;
      black: string;
      cinder: string;
      blaze: string;
      smoke: string;
      charcoal: string;
      ember: string;
      ash: string;
      coal: string;
    };
  }
}

// Create a theme instance.
const theme = createTheme({
  palette: {
    primary: {
      main: "#0157FF",
      light: "rgba(0,0,0,0)",
      dark: "#111D3B",
    },
    secondary: {
      main: "rgba(17, 29, 59, 0.5)",
      light: "rgba(17, 29, 59, 0.05)",
    },
    error: {
      main: red.A400,
    },
    info: {
      main: "#ffffff",
    },
    custom: {
      white: "#FFFFFF",
      black: "rgb(0,0,0)",
      cinder: "#525259",
      blaze: "#F01446",
      smoke: "#F5F5F6",
      charcoal: "#292938",
      ember: "#9D2235",
      ash: "#CACAC7",
      coal: "#303250",
      // coal: '#171725',
    },
  },

  // breakpoints: {
  // 	values: {
  // 		xs: 576,
  // 		mobile: 0,
  // 		tablet: 640,
  // 		laptop: 1024,
  // 		desktop: 1366,
  // 		tv: 1201,
  // 	},
  // },
  typography: {
    fontFamily: ["Poppins"].join(","),
  },
});

export default theme;
